module.exports = __webpack_public_path__ + "media/sonnerie.52f2d170.mp3";